import { usePagination, useActions } from "@nosto/preact"
import Icon from "./elements/Icon"

function PageLink({ onClick, href, className, ariaLabel, children }) {
    return (
        <a
            class={`ns-page-link ns-folio-reg ns-block ns-relative ns-w-100 ns-h-100 ${className}`}
            href={href}
            aria-label={ariaLabel}
            onClick={onClick}
        >
            {children}
        </a>
    )
}

export default function Pagination() {
    const { prev, first, pages, last, next } = usePagination({
        width: 5
    })

    const { updateSearch, simulateUpdateSearch } = useActions()

    function pageLinkProps({ from }) {
        return {
            onClick: e => {
                e.preventDefault()
                updateSearch({ products: { from } })
                scrollTo(0, 0)
            },
            href: simulateUpdateSearch({ products: { from } }).url
        }
    }

    return (
        <nav class="ns-pagination ns-w-100" aria-label="Pagination navigation">
            <ul class="ns-flex ns-flex-nowrap ns-justify-center ns-items-center ns-list-unstyled ns-page-width ns-x-spacing ns-y-spacing">
                {/* {prev && (
                    <li>
                        <PageLink {...pageLinkProps(prev)} className="ns-previous" ariaLabel="Previous page">
                            <Icon name="arrow" className="ns-page-prev-icon" />
                        </PageLink>
                    </li>
                )} */}

                {first && (
                    <>
                        <li>
                            <PageLink {...pageLinkProps(first)} ariaLabel="First page">
                                {first.page}
                            </PageLink>
                        </li>
                        <li><span class="ns-page-link">...</span></li>
                    </>
                )}

                {pages.map(page => (
                    <li key={page.page} class={`${page.current ? "ns-active" : ""}`}>
                        <PageLink ariaLabel={`${page.page} page`} {...pageLinkProps(page)}>{page.page}</PageLink>
                    </li>
                ))}

                {last && (
                    <>
                        <li><span class="ns-page-link">...</span></li>
                        <li>
                            <PageLink {...pageLinkProps(last)} ariaLabel="Last page">{last.page}</PageLink>
                        </li>
                    </>
                )}

                {/* {next && (
                    <li>
                        <PageLink {...pageLinkProps(next)} className="ns-next" ariaLabel="Next page">
                            <Icon name="arrow" className="ns-page-next-icon" />
                        </PageLink>
                    </li>
                )} */}
            </ul>
        </nav>
    )
}
